// AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if user is already logged in from sessionStorage
        const token = sessionStorage.getItem('accessToken');
        const userEmail = sessionStorage.getItem('userEmail');
        const userRole = sessionStorage.getItem('userRole');

        if (token && userEmail) {
            setUser({
                email: userEmail,
                role: userRole || 'general',
                isAdmin: userRole === 'admin'
            });
        }
        setLoading(false);
    }, []);

    const login = (email, role = 'general') => {
        const userData = {
            email,
            role,
            isAdmin: role === 'admin'
        };
        setUser(userData);
        sessionStorage.setItem('userEmail', email);
        sessionStorage.setItem('userRole', role);
        return userData;
    };

    const logout = () => {
        setUser(null);
        sessionStorage.removeItem('userEmail');
        sessionStorage.removeItem('userRole');
        sessionStorage.setItem('accessToken', '');
    };

    const isAdmin = () => {
        return user?.isAdmin || false;
    };

    const value = {
        user,
        loading,
        login,
        logout,
        isAdmin
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};